import { render, staticRenderFns } from "./ManageAppointment.vue?vue&type=template&id=eebcb9b2&scoped=true"
import script from "./ManageAppointment.vue?vue&type=script&lang=js"
export * from "./ManageAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eebcb9b2",
  null
  
)

export default component.exports